import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { FindInventoryLocationsResult, InventoryLocationFilter } from 'lib/services/inventories/locationsApi';
import { type UseQueryOptions, type UseQueryResult, useQuery } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useInventoryLocations = (
  filter: InventoryLocationFilter,
  options?: UseQueryOptions<FindInventoryLocationsResult, Error>,
): UseQueryResult<FindInventoryLocationsResult> => {
  const notify = useAppNotifications();
  const { inventoryLocationsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.inventoryLocations.filter(filter),
    queryFn: async () => await inventoryLocationsApiClient.find(filter),
    onError: error =>
      notify.error({
        message: 'There was an error while fetching inventory locations',
        description: getErrorMessage(error),
      }),
    ...options,
  });
};
